import React from "react"
import { Link } from "react-router-dom"

// A signed-in address that no page answers (allRoutes.js, last route), inside the usual layout instead of a blank page.
const PageNotFound = () => (
  <div className="page-content"><div className="container-fluid">
    <div className="card"><div className="card-body">
      <h4>Page not found</h4>
      <p>This page does not exist or is no longer available.</p>
      <Link className="btn btn-primary" to="/dashboard">Back to dashboard</Link>
    </div></div>
  </div></div>
)

export default PageNotFound
